export default __webpack_public_path__ + "static/media/IMG_9952.50d5fd85.jpeg";